import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`

  * {
    padding: 0;
    /* @file: src/styles/GlobalStyles.js
       IMPORTANTE PARA TV:
       - Antes usávamos fontes remotas do Google Fonts (Open Sans, Stick No Bills) via HTTPS.
       - Para compatibilidade com TVs antigas (sem HTTPS moderno), removemos esses CDNs.
       - Aqui definimos uma pilha de fontes com fallbacks de sistema para manter legibilidade,
         mesmo sem carregar as fontes customizadas.
    */
  }

  body {
    /* Usa Open Sans se estiver instalada localmente; caso contrário, cai para fontes de sistema. */
    font-family: "Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI",
      Roboto, "Helvetica Neue", Arial, sans-serif;
    overflow-x: hidden;
  }

  .btn-pri {
    background: #B11A1A;
    border: none;
    color: #fff;
    height: 38px;

    :hover {
      background: #e13636;
      color: #fff;
    }

    :active {
      background: #e13636 !important;
      border-color: #B11A1A !important;
      box-shadow: 0 0 0 0.25rem rgb(236 177 19 / 50%) !important;
    }
  }
  
  .btn-outline-secondary {
    :hover {
      background: #3A3334;
    }
  }

  .Toastify__toast--success {
    background: #C7E2D3 !important;
  }
  
  .Toastify__toast--error {
    background: #F9CDD0 !important;
  }
`;
